<template>
  <div class="login inner_training" :class="{ hideIframe: !is_wechat }">
    <i class="cover-box" :class="{ is_register, is_forget }"></i>
    <div class="login-icon">
      <img src="~@/assets/images/inner_training/logo-icon.png" alt="">
      <span>舟道教育科技</span>
    </div>
    <div class="login-box">
      <div class="login-content">
        <div class="title-text fadeIn">
          <span v-if="is_register">注册</span>
          <span v-else-if="is_forget">找回</span>
          <span v-else>登录</span>
        </div>

        <div class="login-input-box fadeIn" v-if="!is_register && !is_forget && !is_wechat">
          <button class="wechat-button my-button" @click="wechatLogin()">
            <div class="wechat-text">
              <img src="~@/assets/images/yuanxi/wechat.png" alt="">
              <span>微信登录</span>
            </div>
          </button>
          <div class="division">
            <i></i>
            <span>or</span>
            <i></i>
          </div>
          <div class="lp-item">
            <div>账号</div>
            <a-input v-model="account" class="my-input" placeholder="请输入手机号" :maxLength="20" />
          </div>
          <div class="lp-item">
            <div>密码</div>
            <a-input-password v-model="password" type="password" placeholder="请输入密码" :maxLength="20"
              @keyup.enter="login()" />
          </div>
          <a-button class="lp-button my-button" type="primary" :loading="logining" @click="login()">登录</a-button>
          <div class="lp-info">
            <div class="a-text" @click="is_forget = true">忘记密码？</div>
            <div>
              <span>没有注册？</span>
              <span class="a-text info-register" @click="is_register = true">立即注册</span>
            </div>
          </div>
        </div>
        <!-- 微信登录二维码 -->
        <div class="login-input-box fadeIn" :class="{ hide: !is_wechat }">
          <div id="wx-login-qrCode"></div>
          <div class="a-text" @click="is_wechat = false">手机号登录</div>
        </div>
        <!-- 注册 -->
        <div class="login-input-box register-box fadeIn" v-if="is_register">
          <div class="lp-item">
            <div>账号</div>
            <a-input v-model="formRegister.phone" class="my-input" placeholder="请输入手机号" :maxLength="11" />
          </div>
          <div class="lp-item">
            <div>验证码</div>
            <div class="code-box">
              <a-input v-model="formRegister.code" class="my-input" placeholder="请输入验证码" suffix :maxLength="6" />
              <!-- 倒计时 -->
              <span class="get-code" v-if="count == 0" @click="getPhoneCode">获取验证码</span>
              <span class="get-code" v-else>{{ count }}秒后重试</span>
            </div>
          </div>
          <div class="lp-item">
            <div>密码</div>
            <a-input-password v-model="formRegister.password" type="password" placeholder="请输入密码" :maxLength="20" />
          </div>
          <div class="lp-item">
            <div>验证密码</div>
            <a-input-password v-model="formRegister.checkPassword" type="password" placeholder="请输入再次输入密码"
              :maxLength="20" />
          </div>
          <div class="lp-item">
            <div>姓名</div>
            <a-input v-model="formRegister.nickName" class="my-input" placeholder="请输入姓名或昵称" :maxLength="20" />
          </div>
          <a-button class="lp-button my-button" type="primary" :loading="registering"
            @click="checkCode()">确认注册</a-button>
          <div class="a-text" @click="returnLogin()">返回登陆</div>
        </div>
        <!-- 忘记密码 -->
        <div class="login-input-box forget-box fadeIn" v-if="is_forget">
          <div class="fadeIn" v-if="forgetStep == 1">
            <div class="lp-item">
              <div>账号</div>
              <a-input v-model="formRegister.phone" class="my-input" placeholder="请输入手机号" :maxLength="11" />
            </div>
            <div class="lp-item">
              <div>验证码</div>
              <div class="code-box">
                <a-input v-model="formRegister.code" class="my-input" placeholder="请输入验证码" suffix :maxLength="6" />
                <!-- 倒计时 -->
                <span class="get-code" v-if="count == 0" @click="getPhoneCode">获取验证码</span>
                <span class="get-code" v-else>{{ count }}秒后重试</span>
              </div>
            </div>
            <a-button class="lp-button my-button" type="primary" :loading="registering"
              @click="checkCode()">下一步</a-button>
          </div>
          <div class="fadeIn" v-if="forgetStep == 2">
            <div class="lp-item">
              <div>密码</div>
              <a-input-password v-model="formRegister.password" type="password" placeholder="请输入密码" :maxLength="20" />
            </div>
            <div class="lp-item">
              <div>验证密码</div>
              <a-input-password v-model="formRegister.checkPassword" type="password" placeholder="请输入再次输入密码"
                :maxLength="20" />
            </div>
            <a-button class="lp-button my-button" type="primary" :loading="editPasswording"
              @click="editPassword()">确认修改</a-button>
          </div>
          <div class="a-text" @click="returnLogin()">返回登陆</div>
        </div>
      </div>

      <!-- 公安备案 -->
      <div style="text-align: center;margin:0 auto; padding-top:20px;">
        <a target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52990002000053"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img
            src="~@/assets/images/public_security.png" style="float:left;" />
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#999;">贵公网安备52990002000053号
          </p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { PASSPORT_SERVER } from '@/config/url';
import { PC_APPID, SCOPE } from '@/config/wx';
import { addQueryString } from '@/util/url';

export default {
  name: "inner_training_login",
  components: {},
  data() {
    return {
      userGuid: '',
      formRegister: {
        phone: '',
        password: '',
        checkPassword: '',
        nickName: '',
      },

      loading: true,
      is_wechat: false,
      is_register: false,
      is_forget: false,
      is_phone: false,

      logining: false,
      registering: false,
      editPasswording: false,

      account: '',
      password: '',
      redirectURI: '',

      count: 0,
      forgetStep: 1,

      pageContent: null
    }
  },
  async mounted() {
    const search = new URLSearchParams(location.search);
    this.redirectURI = search.get('redirectURI');

    this.judgePhone();
    window.addEventListener('resize', this.judgePhone);

    //验证本地token
    const verifyRet = await this.$api.passport.verifyToken()
    if(verifyRet.status === 1) location.href = addQueryString(this.redirectURI, 'token', verifyRet.token);

    let icon_url = require('@/assets/images/inner_training/icon.png');
    this.changeFavicon(icon_url);
  },
  methods: {
    //判断手机端
    judgePhone() {
      let w_width = window.innerWidth;
      this.is_phone = w_width < 700;
    },
    //微信登陆
    wechatLogin() {
      this.is_wechat = true;
      this.wxloginForPC();
    },
    //生成登录二维码
    wxloginForPC() {
      const wxApiRedirectURI = `${PASSPORT_SERVER}/wx/client_strict?redirectURI=${this.redirectURI}`;
      let href = `https://cdn.lessonplan.cn/Public/CSS/wx-login-style.css`;
      //eslint-disable-next-line
      new WxLogin({
        id: 'wx-login-qrCode',
        appid: PC_APPID,
        scope: SCOPE,
        redirect_uri: encodeURIComponent(wxApiRedirectURI),
        href: href,
        fast_login: 1,
      })
    },
    //账号密码登录
    async login() {
      let msg = '';
      if(!this.account || !this.password) msg = '请输入正确的账号密码';
      if(msg) return this.$message.warning(msg);

      this.logining = true;
      //登录
      let res = await this.$api.passport.auth({ username: this.account, password: this.password });
      this.logining = false;

      if(res.status != 1) return this.$message.warning('用户名或密码不正确');
      this.$message.success('登陆成功');
      location.href = addQueryString(this.redirectURI, 'token', res.token);
    },
    //获取验证码
    async getPhoneCode() {
      let formRegister = this.formRegister;
      let count = this.count;

      if(!formRegister.phone || formRegister.phone.length != 11) return this.$message.warning('请先输入正确的手机号');
      count = 60;
      count -= 1;
      this.count = count;

      let that = this;
      let countTime = setInterval(() => {
        count -= 1;
        that.count = count;
        if(count == 0) {
          clearInterval(countTime);
        }
      }, 1000);
      this.$message.success('短信已发送，请注意查收');

      let res = await this.$api.account.sendSms(formRegister.phone);
      if(res.code != 1) return this.$message.error(res.msg);
      formRegister.codeGuid = res.data.PK_CodeGuid;
    },
    //验证忘记密码
    async checkCode() {
      let registering = this.registering;
      if(registering) return;
      let { phone, codeGuid, code } = this.formRegister;

      let msg = ``;
      if(!phone || phone.length != 11) msg = '请输入正确的手机号';
      else if(!codeGuid) msg = '请先获取验证码';
      if(msg) return this.$message.warning(msg);

      registering = true;
      //先验证验证码
      let res = await this.$api.account.checkcode(codeGuid, code);
      if(res.code != 1) {
        this.registering = false;
        return this.$message.error(res.msg);
      }

      if(this.is_register) this.register();
      else {
        //找到用户
        let userList = await this.$api.account.getClientByUser(phone).then(res => res.data || []);
        if(userList.length == 0) {
          registering = false;
          return this.$message.warning("未找到该用户，请确认手机号是否正确");
        }
        this.userGuid = userList[0].PK_UserGuid;
        registering = false;
        this.forgetStep = 2;
      }
    },
    //确定注册
    async register() {
      let { phone, password, checkPassword, nickName } = this.formRegister;
      let msg = '';

      if(!/^1[3456789]\d{9}$/.test(phone)) msg = '请输入正确的手机号';
      else if(!password || password.length < 6) msg = '密码不符合规则，请输入6位以上密码';
      else if(checkPassword != password) msg = '两次输入的密码不一致';
      else if(!nickName) msg = '请输入姓名';
      if(msg) return this.$message.warning(msg);

      nickName = nickName.trim();
      let res = await this.$api.account.register({ Name: phone, Phone: phone, Password: password, NickName: nickName });
      this.registering = false;
      if(res.status != 1) {
        this.formRegister.code = '';
        this.formRegister.codeGuid = '';
        return this.$message.error(res.err);
      }

      this.$message.success('注册成功');
      this.returnLogin();
    },
    //修改密码
    async editPassword() {
      let editPasswording = this.editPasswording;
      if(editPasswording) return;
      let { password, checkPassword } = this.formRegister;

      let msg = '';
      if(!password) msg = '请输入新密码';
      else if(checkPassword.length < 6) msg = '请至少输入6位密码';
      else if(!checkPassword) msg = '请再次输入新密码';
      else if(password != checkPassword) msg = '两次输入的密码不一致';

      if(msg) return this.$message.warning(msg);

      editPasswording = true;
      let res = await this.$api.account.setNewPassword({
        PK_UserGuid: this.userGuid,
        Password: password
      });
      editPasswording = false;
      if(res.status != 1) return this.$message.error(res.message);

      this.$message.success('密码重置成功');
      this.forgetStep = 1;
      this.returnLogin();
    },

    //返回登录
    async returnLogin() {
      this.is_wechat = false;
      this.is_register = false;
      this.is_forget = false;
      this.formRegister = {
        phone: '',
        password: '',
        checkPassword: '',
        nickName: '',
        codeGuid: '',
        code: ''
      }
      //隐藏二维码
      document.querySelector('iframe');
    },
    //修改标签图标
    changeFavicon(link) {
      document.title = '舟道企业内训平台';
      let $favicon = document.querySelector('link[rel="icon"]');
      if($favicon !== null) {
        $favicon.href = link;
      } else {
        $favicon = document.createElement("link");
        $favicon.rel = "icon";
        $favicon.href = link;
        document.head.appendChild($favicon);
      }
    },
    //组件销毁
    beforeUnmount() {
      window.removeEventListener('resize', cancalDebounce);
    }
  }
}
</script>

<style scoped lang="scss">
@import "./login.scss";
</style>